import * as React from "react";
const SvgDash = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "currentColor", d: "M18 10.5v3H6v-3z" })));
export default SvgDash;
//# sourceMappingURL=Dash.js.map